export default () => {
  return {
    config: {},
    lastFetchedAt: null,
  };
};
